import request from "@/axios.js";

export default class Netlink {
	/**
	 * Netlink class
	 * @property {string} urlBought - a urlBought.
	 * @property {string} anchorType - a anchorType.
	 * @property {string} landingPage - an landingPage.
	 * @property {string} linkType - a linkType.
	 * @property {number} domainAuthority - a domainAuthority.
	 * @property {number} pageAuthority - a pageAuthority.
	 * @property {number} trustFlow - a trustFlow.
	 * @property {number} citationFlow - a citationFlow.
	 * @property {number} externalLinks - a externalLinks.
	 * @property {number} refDomains - an refDomains.
	 */
	constructor(netlink) {
		this.id = netlink.id;
		this.urlBought = netlink.urlBought;
		this.anchorType = netlink.anchorType;
		this.landingPage = netlink.landingPage;
		this.status = netlink.status;
		this.linkType = netlink.linkType;
		this.domainAuthority = netlink.domainAuthority;
		this.pageAuthority = netlink.pageAuthority;
		this.trustFlow = netlink.trustFlow;
		this.citationFlow = netlink.citationFlow;
		this.externalLinks = netlink.externalLinks;
		this.refDomains = netlink.refDomains;
		this.purchase_id = netlink.purchase_id;
		this.society_id = netlink.society_id;
		this.creation_date = netlink.creation_date;
		this.dns_id = netlink.dns_id;
		this.contract_id = netlink.contract_id;
		this.price = netlink.price;
		this.renew_duration = netlink.renew_duration;
		this.provider_id = netlink.provider_id;
		this.editMain = netlink.editMain;
		this.period_date = netlink.period_date;
	}

	static getFormFields(){
		let today = new Date(Date.now());
		let todayString = today.toISOString();
		todayString = todayString.substring(0, 10);
		todayString = todayString + " 02:00:00";

		return {
			id: null,
			urlBought: null,
			anchorType: null,
			landingPage: null,
			status: 0,
			linkType: null,
			domainAuthority: null,
			pageAuthority: null,
			trustFlow: 0,
			citationFlow: 0,
			externalLinks: 0,
			refDomains: 0,
			purchase_id: null,
			society_id: null,
			creation_date: todayString,
			dns_id: null,
			contract_id: null,
			price: 0,
			renew_duration: 0,
			renew_date: todayString,
			provider_id: null,
			editMain: true,
			period_date: null,
		};
	}

	create(callback){
		request.post("/netlink/add", this)
			.then(res => {
				callback(null, res);
			})
			.catch(err => {
				callback(err, null);
			});
	}

	update(callback){
		request.post("/netlink/edit", this)
			.then(res => {
				callback(null, res);
			})
			.catch(err => {
				callback(err, null);
			});
	}
	static getAll(){
		return new Promise((resolve, reject) => {
			request.get("/netlink/all")
				.then(res => {
					resolve(res.data);
				})
				.catch(err => {
					reject(err);
				});
		});
	}
	static createNetlink(netlink){
		return new Promise((resolve, reject) => {
			request.post("/netlink/v2/add", netlink)
				.then(res => {
					resolve(res.data);
				})
				.catch(err => {
					reject(err);
				});
		});
	}
	static updateNetlink(id, netlink){
		return new Promise((resolve, reject) => {
			request.post("/netlink/v2/edit", netlink)
				.then(res => {
					resolve(res.data);
				})
				.catch(err => {
					reject(err);
				});
		});
	}


	static getNetlinksForPurchase(purchaseId, callback){
		request.get("/netlink/getp/" + purchaseId)
			.then(res => {
				callback(null, res);
			})
			.catch(err => {
				callback(err, null);
			});
	}

	static getNetlinksForRecurringPurchase(recurringPurchaseId, callback){
		request.get("/netlink/getrp/" + recurringPurchaseId)
			.then(res => {
				callback(null, res);
			})
			.catch(err => {
				callback(err, null);
			});
	}

	static delete(netlinkId, callback){
		request.delete("/netlink/delete/" + netlinkId)
			.then(res => {
				callback(null, res);
			})
			.catch(err => {
				callback(err, null);
			});
	}
	static deleteAsync(netlinkId){
		return new Promise((resolve, reject) => {
			request.delete("/netlink/delete/" + netlinkId)
				.then(res => {
					resolve(res.data);
				})
				.catch(err => {
					reject(err);
				});
		});
	}
	static getNetlinksForContract(contractId){
		return new Promise((resolve, reject) => {
			request.get("/netlink/getFromContract/" + contractId)
				.then(res => {
					resolve(res.data);
				})
				.catch(err => {
					reject(err);
				});
		});
	}
	static getFilteredNetlinks(queries, offset){
		return new Promise((resolve, reject) => {
			request.post("/netlink/getFilteredNetlinks?page="+ offset , queries)
				.then(res => {
					resolve(res.data);
				})
				.catch(err => {
					reject(err);
				});
		});
	}
	static getTypes(){
		return new Promise((resolve, reject) => {
			request.get("/netlink/type/all/")
				.then(res => {
					resolve(res.data);
				})
				.catch(err => {
					reject(err);
				});
		});
	}
	static getThemas(){
		return new Promise((resolve, reject) => {
			request.get("/netlink/thema/all")
				.then(res => {
					resolve(res.data);
				})
				.catch(err => {
					reject(err);
				});
		});
	}
	static getNetlinkStatus(){
		return new Promise((resolve, reject) => {
			request.get("/netlink/netlinkStatus")
				.then(res => {
					resolve(res.data);
				})
				.catch(err => {
					reject(err);
				});
		});
	}
	static getNetlinkAnchorTypes(){
		return new Promise((resolve, reject) => {
			request.get("/netlink/anchorTypes")
				.then(res => {
					resolve(res.data);
				})
				.catch(err => {
					reject(err);
				});
		});
	}
		static getBudgetRecap(body){
		return new Promise((resolve, reject) => {
			request.post("/netlink/getBudgetRecap", body)
				.then(res => {
					resolve(res.data);
				})
				.catch(err => {
					reject(err);
				});
		});
	}
	/**
	 * Budget recap computed live, grouped contract -> prestation. Replays each
	 * prestation month by month instead of reading netlinks_budget_sheet, so no
	 * figure it returns can be a stale stored row.
	 * @param {Object} body - { period } in MM/YYYY
	 */
	static getLiveBudgetRecap(body){
		return new Promise((resolve, reject) => {
			request.post("/netlink/getLiveBudgetRecap", body)
				.then(res => {
					resolve(res.data);
				})
				.catch(err => {
					reject(err);
				});
		});
	}
	/**
	 * Save a budget correction for the live budget table. Upserts the row and
	 * skips the recap replay, which the live engine does not need.
	 * @param {Object} body - { mission_id, contract_id, period, corrected_budget, correct_budget_note? }
	 */
	static updateLiveCorrection(body){
		return new Promise((resolve, reject) => {
			request.patch("/netlink/liveCorrection", body)
				.then(res => {
					resolve(res.data);
				})
				.catch(err => {
					reject(err);
				});
		});
	}
	static updateCorrectedBudget(body){
		return new Promise((resolve, reject) => {
			request.patch("/netlink/correctedBudget", body)
				.then(res => {
					resolve(res.data);
				})
				.catch(err => {
					reject(err);
				});
		});
	}

	/**
	 * Save only the note for a correction. Separate endpoint because it skips the
	 * recap replay that updateCorrectedBudgetMission triggers.
	 */
	static updateCorrectedBudgetNote(body){
		return new Promise((resolve, reject) => {
			request.patch("/netlink/correctedBudgetNote", body)
				.then(res => {
					resolve(res.data);
				})
				.catch(err => {
					reject(err);
				});
		});
	}
	static updateCorrectedBudgetMission(body){
		return new Promise((resolve, reject) => {
			request.patch("/netlink/correctedBudgetMission", body)
				.then(res => {
					resolve(res.data);
				})
				.catch(err => {
					reject(err);
				});
		});
	}

	static checkDomain(url_bought, society_id = null){
		return new Promise((resolve, reject) => {
			const payload = { url_bought };
			if (society_id) {
				payload.society_id = society_id;
			}
			request.post("/netlink/checkDomain", payload)
				.then(res => {
					resolve(res.data);
				})
				.catch(err => {
					reject(err);
				});
		});
	}

}
